import React from 'react';

import { List } from './List';
import { Add } from './Add';
import { Edit } from './Edit';

export const materialsRoutes = {
  path: '/materials',
  children: [
    {
      path: '',
      element: <List />,
    },
    {
      path: 'add',
      element: <Add />,
    },
    {
      path: ':id/edit',
      element: <Edit />,
    },
  ],
};
